RivalIQ.apps.Insights.module('models', function (models, App, Backbone, Marionette, $, _, CompareData) {

    'use strict';

    models.Post = Backbone.Model.extend({
        isType: function (type) {

            const me = this;
            return (type === me.get('type'));
        },

        isSource: function (source) {

            const me = this;
            return (source === me.get('source'));
        },

        isNativeVideo: function () {

            const me = this;
            const link = me.getDisplayProperty('link');
            // NOTE if the source is Facebook then we need to check to make sure
            // that that we determine whether it is native or third party
            return (me.isType('video') && (!me.isSource(CompareData.sources.FACEBOOK) || (/www\.facebook\.com/).test(link)));
        },

        calculateEngagement: function () {

            const me = this;

            const json = me.toJSON();

            let engagement = 0;
            let engagementRate = 0;

            if (me.isSource(CompareData.sources.FACEBOOK)) {
                engagement = json.fb_insights_engagement;
                engagementRate = json.insights_engagement_rate;
            } else if (me.isSource(CompareData.sources.LINKEDIN)) {
                engagement = json.li_insights_engagement;
                engagementRate = json.li_insights_engagement_rate;
            }

            return {
                insights_engagement: engagement,
                insights_engagement_rate: engagementRate
            };
        },

        getDisplayProperty: function (property) {

            const me = this;
            const data = me.toJSON();
            return _.get(data, ['rivaliq.display', property].join('.'));
        }
    });

}, RivalIQ.data.CompareData);
